import script from "./MainInfoAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./MainInfoAddress.vue?vue&type=script&setup=true&lang=js"

import "./MainInfoAddress.vue?vue&type=style&index=0&id=160cd75d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-160cd75d"]])

export default __exports__